export default {
  lang: 'Language',
  es: 'Español',
  en: 'English',
  spanish: 'Español',
  english: 'English'
};
